/* Codes cohérents (2026-11-02) — recalcule dans le navigateur le code proposé hors fiche produit
   (tiroir panier, accueil, menu), pour qu'il soit le MÊME que celui de la fiche et du bandeau.
   Le Liquid (snippets/codes-campagne.liquid) a déjà rendu la bonne valeur ; ce script ne sert
   qu'aux pages servies depuis le cache au changement de période, et au test ?promo_date=.
   Le planning est lu sur le bandeau lui-même (.camp-bandeau[data-calendrier]) : rien à recopier.

   Balisage :
     [data-cc-racine]           data-cc-code-hors="CODE10"  → data-code (lu par le bouton Copier)
                                data-cc-aria-hors / data-cc-aria-camp (gabarit) → aria-label
     [data-cc="{remise}"]       gabarit affiché pendant une campagne ; data-cc-defaut = texte hors campagne
     [data-cc-si="camp|hors"]   visible seulement pendant / hors campagne
   Gabarits : {code} {remise} {nom}. */
(function () {
  if (window.ccCodesCampagne) return;
  window.ccCodesCampagne = true;

  function periode() {
    var b = document.querySelector('.camp-bandeau[data-calendrier]');
    if (!b) return null;
    var m = /[?&]promo_date=([^&]+)/.exec(window.location.search);
    var t = m ? new Date(decodeURIComponent(m[1])).getTime() : NaN;
    t = Math.floor((isNaN(t) ? Date.now() : t) / 1000);
    var p = null;
    b.getAttribute('data-calendrier').split(';').some(function (ligne) {
      var c = ligne.split('|');
      if (t >= +c[0] && t <= +c[1]) { p = { code: c[5], remise: c[2].replace('-', '−'), nom: c[3] }; return true; }
      return false;
    });
    return p;
  }

  function remplir(gabarit, p) {
    return gabarit.replace(/\{code\}/g, p.code).replace(/\{remise\}/g, p.remise).replace(/\{nom\}/g, p.nom);
  }

  // N'écrire que ce qui change : l'observateur verrait sinon ses propres écritures.
  function texte(el, v) { if (el.textContent !== v) el.textContent = v; }
  function attr(el, n, v) { if (v != null && el.getAttribute(n) !== v) el.setAttribute(n, v); }

  function maj() {
    var p = periode();
    document.querySelectorAll('[data-cc-racine]').forEach(function (r) {
      if (r.hasAttribute('data-cc-code-hors')) attr(r, 'data-code', p ? p.code : r.getAttribute('data-cc-code-hors'));
      var aria = p ? r.getAttribute('data-cc-aria-camp') : r.getAttribute('data-cc-aria-hors');
      if (aria) attr(r, 'aria-label', p ? remplir(aria, p) : aria);
      r.querySelectorAll('[data-cc]').forEach(function (el) {
        texte(el, p ? remplir(el.getAttribute('data-cc'), p) : (el.getAttribute('data-cc-defaut') || ''));
      });
      r.querySelectorAll('[data-cc-si]').forEach(function (el) {
        var voir = (el.getAttribute('data-cc-si') === 'camp') === !!p;
        if (el.hidden === voir) el.hidden = !voir;
      });
    });
  }

  var prevu = false;
  function planifier() {
    if (prevu) return;
    prevu = true;
    (window.requestAnimationFrame || setTimeout)(function () { prevu = false; maj(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', maj); else maj();
  // Le tiroir panier est re-rendu (Section Rendering API) à chaque ajout : on repasse dessus.
  new MutationObserver(planifier).observe(document.documentElement, { childList: true, subtree: true });
})();
